import { render, staticRenderFns } from "./PopupSelect.vue?vue&type=template&id=24e5005b&scoped=true"
import script from "./PopupSelect.vue?vue&type=script&lang=ts"
export * from "./PopupSelect.vue?vue&type=script&lang=ts"
import style0 from "./PopupSelect.vue?vue&type=style&index=0&id=24e5005b&prod&lang=less&scoped=true"
import style1 from "./PopupSelect.vue?vue&type=style&index=1&id=24e5005b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@6.26.3_coffee-script@1.12.7_css-loader@5.2.7_webpack@5.75_86376c8867defa2ab34ac3cb7ab0bafc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e5005b",
  null
  
)

export default component.exports